// removed by extract-text-webpack-plugin
module.exports = {"nf-notifications":"nf-notifications","nf-notifications__header":"nf-notifications__header","nf-notifications__subheader":"nf-notifications__subheader","nf-notifications__card-header":"nf-notifications__card-header","nf-button--add":"nf-button--add","nf-notification-card":"nf-notification-card","nf-notifications__message":"nf-notifications__message","nf-loading":"nf-loading","nf-loading__img":"nf-loading__img","nf-notifications-link":"nf-notifications-link","bid-match-header":"bid-match-header"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BidMatchSettings/BidMatchSettings.scss
// module id = 5433
// module chunks = 1